const USER_UPDATED = (state, user = { products: [] }) => {
  state.user = Object.assign(user, { token: state.user.token })
}

// Set loader
const LOGIN = state => {
  state.loading = true
}

// Manage Login success
const LOGIN_SUCCESS = (state, token) => {
  state.user.token = token // Save token in store
  state.loading = false // Stop loader
  state.error = false // No error => false
}

// Manage Login error
const LOGIN_ERROR = (state) => {
  state.user.token = '' // Remove token in store
  state.loading = false // Stop loader
  state.error = true // Error(s) => true
}

// Manage Logout
const LOGOUT = state => {
  state.user.token = ''
}

export default {
  USER_UPDATED,
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js